const htmlTemplates = {


    version1: (
        lang, title, headline, body, bodyBtnName, bodyBtnLink, 
        subjectLine1, subjectLine2, subjectLine3, 
        preHeader, bodyImage, bodyImageLink, 
        additionalText, additionalTextUnderBTN,   brandName, disclaimer_marketing, viewInBrowserURL, frameColor, logoLink, backgroundColor, buttonGenralColor, buttonTextColor, logo, smalldisclaimer, borderRadius
      ) => `
        

<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">

<head>
    <title>${brandName}</title>

    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
    <meta http-equiv="X-UA-Compatible" content="IE=edge">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <link href="https://fonts.googleapis.com/css2?family=Calibri&display=swap" rel="stylesheet">

    <link href="https://fonts.googleapis.com/css2?family=Poppins&display=swap" rel="stylesheet">
    <!-- <link href='https://fonts.googleapis.com/css?family=Roboto:100,300,500,700' rel='stylesheet' type='text/css'> -->
    <style type="text/css">
        body,
        table,
        td,
        p,
        a,
        li,
        blockquote {
            -webkit-text-size-adjust: 100%;
            -ms-text-size-adjust: 100%;
        }

        h1,
        h2,
        h3,
        h4,
        p,
        td {
            margin: 0;
            padding: 0;
        }

        table,
        td {
            mso-table-lspace: 0pt;
            mso-table-rspace: 0pt;
        }

        img {
            -ms-interpolation-mode: bicubic;
        }

        /* custom styles */
        /* * { box-sizing: border-box; font-family: "Roboto", "Verdana", sans-serif !important; }
         body, table, td { font-family: "Roboto", "Verdana", sans-serif !important; } */
        * {
            box-sizing: border-box;
        font-family: 'Poppins', sans-serif;
        }
  

        body,
        table,
        td {
        font-family: 'Poppins', sans-serif;
        }

        h1,
        h3 {
           color: #fff !important;
        }

        h1 {
            font-size: 23px;
         
        }

        p {
            font-weight: 300;
        color: #fff !important;
            font-size: 16px;
            line-height: 1.5;
        }

        table.footer p {
            font-weight: 300;
            color: #0A1C30 !important;
            font-size: 16px;
            line-height: 1.5;
        }

        table.footer a {
            color: #0A1C30 !important;
        }

        img {
            display: block;
        
        }

        .text-container {
            padding: 25px !important;
        }

        .text-container p {
            font-size: 16px;
        }

        .padding-table {
            padding: 0px;
        }






        @media all and (max-width: 500px) {
            .container {
                width: 100% !important;
                padding: 0 !important;
            }

            tr>.main-table {
                padding: 0px 15px 20px 15px !important;
            }

            td>.header-image {
                width: 100% !important;
            }

            tr>.padding-table {
                padding: 0 5px !important;
            }

            tr>.right-container,
            tr>.left-container {
                display: block !important;
                width: 100% !important;
            }

            tr>.left-container {
                padding: 10px !important;
            }

            tr>.left-container td>h2,
            tr>.left-container td>p {
                text-align: center !important;
            }

            tr>.right-container td>img {
                width: auto !important;
            }

            tr>.right-container,
            .right-container tr>td>img {
                text-align: center !important;
                margin: 0 auto !important;
            }
        }
                   .btnForMobile {
            display: none;
        }

        .orgBtn {
            display: block;
        }

        @media only screen and (max-width: 600px) {
           
        .mobileTD{
                display: none !important;
            }
        }
        @media only screen and (max-width: 600px) {
           
            h1.titleIntext {
                padding: 20px 0px 20px 15px !important;
                width: 175px !important;
                font-size: 19px !important;
            }
                .backImg{
                    padding: 0px !important;
                }
            .btnDeposit {
                padding: 0px !important;
            }

            .btnForMobile {
                display: block !important;
            }

            .orgBtn {
                display: none !important;
            }
        }
    </style>

</head>

 <body bgcolor="#d1d1d1" leftmargin="0" marginheight="0" marginwidth="0" offset="0" topmargin="0" style="background: #d1d1d1; background-color: #d1d1d1;">
<table class="container" style="background: #d1d1d1; background-color: #d1d1d1;" border="0" width="100%" cellspacing="0" cellpadding="0" align="center" bgcolor="#d1d1d1">
<tbody>
<tr>
<td style="background: #d1d1d1; background-color: #d1d1d1;" bgcolor="#d1d1d1">&nbsp;</td>
<td id="main-element" style="background: #d1d1d1; background-color: ${backgroundColor}; padding: 0 0 0px 0; width: 600px;" align="center" valign="top" bgcolor="#d1d1d1" width="600">
<table style="background: #d1d1d1; background-color: #d1d1d1;" border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr style="background-color: #d1d1d1; background: #d1d1d1;">
<td style="line-height: 10px;" colspan="5">&nbsp;</td>
</tr>
<tr>
<td style="display: none !important; visibility: hidden; mso-hide: all; font-size: 1px; columns: #fff; line-height: 1px; max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden;">${preHeader}</td>
</tr>
<tr>
<td style="line-height: 10px;" colspan="5">&nbsp;</td>
</tr>
</tbody>
</table>
<table border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td class="padding-table" style="padding: 10px;">
<table style="background: ${backgroundColor}; padding: 0px 15px 0px 0px;" border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td>&nbsp;</td>
</tr>
<tr>

<td align="left" valign="middle" width="50%;" style="padding: 0px 15px 0px 15px;"><a href="${logoLink}" target="_blank" rel="noopener" ><img align="middle" style="display: block; max-width: 110px;" src="${logo}" alt="${brandName}" width="100%" /></a></td>
<td width="50%" style="float: right; font-size: 18px; color: ${buttonTextColor}; background-color: ${buttonGenralColor}; border-radius: ${borderRadius}px; padding: 5px; display: inline-block; width: 193px; text-align: center;" align="right" valign="top"><a style="color: ${buttonTextColor}; font-size: 18px; text-align: center; text-decoration: none; display: block;" href="${bodyBtnLink}" target="_blank" rel="noopener"><strong> ${bodyBtnName}</strong></a></td>

</tr>
<tr>
<td style="line-height: 10px;" colspan="3">&nbsp;</td>
</tr>
</tbody>
</table>

<table style="background: #d1d1d1; background-color: #d1d1d1;" border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td class="main-table" style="padding: 0px 15px 20px 15px; background: ${backgroundColor}; background-color: ${backgroundColor};">
    <a href="${bodyBtnLink}" target="_blank" rel="noopener"><img width="100%;" alt="img" src="https://assets.userex.com/images/4/690b8724ab6901ec78d3104c4c20f88f/2.png"></a>
<table style="background: ${backgroundColor}; background-color: ${backgroundColor};" border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td style="padding-bottom: 20px;" align="left" valign="top"><br>

     <h1>${headline}</h1>
<br>
<p>${body}</p>
<br />
<table style="border-radius: 5px; background: ${backgroundColor}; background-color: ${backgroundColor};" border="0" width="250px" cellspacing="0" cellpadding="0" align="center">
<tbody>
<tr>
<td style="font-size: 18px; color: ${buttonTextColor}; background-color: ${buttonGenralColor}; border-radius: ${borderRadius}px; padding: 11px; display: inline-block; width: 250px; text-align: center;" align="left" valign="top"><a style="color: ${buttonTextColor}; font-size: 18px; text-align: center; text-decoration: none; display: block;" href="${bodyBtnLink}" target="_blank" rel="noopener"><strong>${bodyBtnName}</strong></a></td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>

<!--Footer start-->
<table style="background: ${backgroundColor}; background-color: ${backgroundColor}; color: #fff;" border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td style="color: #fff;" valign="top">
${additionalText}
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
<table style="background: ${backgroundColor}; background-color: ${backgroundColor};" border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td height="35">&nbsp;</td>
<td align="center" width="600" height="35">&nbsp;</td>
<td height="35">&nbsp;</td>
</tr>
<tr>
<td class="" style="background: ${backgroundColor}; background-color: ${backgroundColor};" align="center" valign="middle" bgcolor="${backgroundColor}" width="100%">
<table class="footer" border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td style="color: #000 !important; font-size: 16px;" align="justify" valign="top">
  ${disclaimer_marketing}
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td height="5">&nbsp;</td>
<td align="center" width="600" height="5">&nbsp;</td>
<td height="5">&nbsp;</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
<td style="background: #d1d1d1; background-color: #d1d1d1;" bgcolor="#d1d1d1">&nbsp;</td>
</tr>
<tr>
<td class="emptyTd" style="background: #d1d1d1; background-color: #d1d1d1;" bgcolor="#d1d1d1" height="45">&nbsp;</td>
<td style="background: #d1d1d1; background-color: #d1d1d1;" align="center" bgcolor="#d1d1d1" width="600" height="45">&nbsp;</td>
<td class="emptyTd" style="background: #d1d1d1; background-color: #d1d1d1;" bgcolor="#d1d1d1" height="45">&nbsp;</td>
</tr>
</tbody>
</table>
</body>

</html>
      `,

    version2: (
      lang, title, headline, body, bodyBtnName, bodyBtnLink, 
      subjectLine1, subjectLine2, subjectLine3, 
      preHeader, bodyImage, bodyImageLink, 
      additionalText, additionalTextUnderBTN,   brandName, disclaimer_marketing, viewInBrowserURL, frameColor, logoLink, backgroundColor, buttonGenralColor, buttonTextColor, logo, smalldisclaimer, borderRadius
    ) => `
      <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
 <html xmlns="http://www.w3.org/1999/xhtml">
 <head>
     <title>Template</title>
     
     <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
     <meta http-equiv="X-UA-Compatible" content="IE=edge">
     <meta name="viewport" content="width=device-width, initial-scale=1.0">
         <link href="https://fonts.googleapis.com/css2?family=Calibri&display=swap" rel="stylesheet">

     <link href="https://fonts.googleapis.com/css2?family=Poppins&display=swap" rel="stylesheet">
     <!-- <link href='https://fonts.googleapis.com/css?family=Roboto:100,300,500,700' rel='stylesheet' type='text/css'> -->
     <style type="text/css">
         body,
         table,
         td,
         p,
         a,
         li,
         blockquote {
             -webkit-text-size-adjust: 100%;
             -ms-text-size-adjust: 100%;
         }
 
         h1,
         h2,
         h3,
         h4,
         p,
         td {
             margin: 0;
             padding: 0;
         }
 
         table,
         td {
             mso-table-lspace: 0pt;
             mso-table-rspace: 0pt;
         }
 
         img {
             -ms-interpolation-mode: bicubic;
         }
 
         /* custom styles */
         /* * { box-sizing: border-box; font-family: "Roboto", "Verdana", sans-serif !important; }
          body, table, td { font-family: "Roboto", "Verdana", sans-serif !important; } */
         * {
             box-sizing: border-box;
         font-family: 'Poppins', sans-serif;
         }
   
 
         body,
         table,
         td {
         font-family: 'Poppins', sans-serif;
         }
 
         h1,
         h3 {
            color: #131938 !important;
         }
 
         h1 {
             font-size: 23px;
        
         }
 
         p {
             font-weight: 300;
        
             font-size: 16px;
             line-height: 1.5;
         }
 
         table.footer p {
             font-weight: 300;
             color: #0A1C30 !important;
             font-size: 16px;
             line-height: 1.5;
         }
 
         table.footer a {
             color: #0A1C30 !important;
         }
 
         img {
             display: block;
         
         }
 
         .text-container {
             padding: 25px !important;
         }
 
         .text-container p {
             font-size: 16px;
         }
 
         .padding-table {
             padding: 0px;
         }
 

 
 
 
 
         @media all and (max-width: 500px) {
             .container {
                 width: 100% !important;
                 padding: 0 !important;
             }
 
             tr>.main-table {
                 padding: 0px 15px 20px 15px !important;
             }
 
             td>.header-image {
                 width: 100% !important;
             }
 
             tr>.padding-table {
                 padding: 0 5px !important;
             }
 
             tr>.right-container,
             tr>.left-container {
                 display: block !important;
                 width: 100% !important;
             }
 
             tr>.left-container {
                 padding: 10px !important;
             }
 
             tr>.left-container td>h2,
             tr>.left-container td>p {
                 text-align: center !important;
             }
 
             tr>.right-container td>img {
                 width: auto !important;
             }
 
             tr>.right-container,
             .right-container tr>td>img {
                 text-align: center !important;
                 margin: 0 auto !important;
             }
         }
                    .btnForMobile {
             display: none;
         }
 
         .orgBtn {
             display: block;
         }
 
         @media only screen and (max-width: 600px) {
            
         .mobileTD{
                 display: none !important;
             }
         }
         @media only screen and (max-width: 600px) {
            
             h1.titleIntext {
                 padding: 20px 0px 20px 15px !important;
                 width: 175px !important;
                 font-size: 19px !important;
             }
                 .backImg{
                     padding: 0px !important;
                 }
             .btnMain {
                 padding: 0px !important;
             }
 
             .btnForMobile {
                 display: block !important;
             }
 
             .orgBtn {
                 display: none !important;
             }
         }
     </style>
       
 </head>
 <body bgcolor="#d1d1d1" leftmargin="0" marginheight="0" marginwidth="0" offset="0" topmargin="0" style="background: #d1d1d1; background-color: #d1d1d1;">
<table class="container" style="background: #d1d1d1; background-color: #d1d1d1;" border="0" width="100%" cellspacing="0" cellpadding="0" align="center" bgcolor="#d1d1d1">
<tbody>
<tr>
<td>&nbsp;</td>
<td id="main-element" style="background: #d1d1d1; background-color: #d1d1d1; padding: 0 0 0px 0; width: 620px;" align="center" valign="top" bgcolor="#d1d1d1" width="620">
<table border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td class="padding-table" style="padding: 0 10px;">
<table style="background: #d1d1d1; background-color: #d1d1d1;" border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td height="5">&nbsp;</td>
<td align="center" width="620" height="5">&nbsp;</td>
<td height="5">&nbsp;</td>
<td style="display: none !important; visibility: hidden; mso-hide: all; font-size: 1px; color: ${backgroundColor}; line-height: 1px; max-height: 0px; max-width: 0px; opacity: 0; overflow: hidden;">${preHeader}</td>
</tr>
<tr>
<td class="padding-table" style="padding: 0px; background: #d1d1d1; background-color: #d1d1d1;" valign="middle" bgcolor="#d1d1d1" width="50%">&nbsp;</td>
<td class="" style="background: #d1d1d1; background-color: #d1d1d1;" align="right" valign="middle" bgcolor="#d1d1d1" width="50%">
</td>
</tr>
<tr>
<td height="5">&nbsp;</td>
<td align="center" width="620" height="5">&nbsp;</td>
<td height="5">&nbsp;</td>
</tr>
</tbody>
</table>
<table style="background: ${backgroundColor};" border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td style="line-height: 10px;" colspan="3">&nbsp;</td>
</tr>
<tr>
<td class="brandLogo" align="center" valign="top">
     <a href="${logoLink}" target="_blank" rel="noopener"> <img style="display: block; width: 100%; max-width: 110px;" src="${logo}" alt="${brandName}" /></a>
</td>
</tr>
<tr>
<td style="line-height: 10px;" colspan="3">&nbsp;</td>
</tr>
</tbody>
</table>
<table style="background: ${backgroundColor}; background-color: ${backgroundColor};" border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td style="padding: 0px;" width="100%">
<table style="background: ${backgroundColor}; background-color: ${backgroundColor};" border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td class="esd-structure es-p40t es-p20r es-p20l esd-checked" align="left">
<table width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td class="esd-container-frame" align="center" valign="top" width="560">
<table style="border-collapse: separate;" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td class="esd-structure es-p40t es-p20r es-p20l esd-checked backImg" style="height: 150px; max-height: 140px; background-image: url('https://assets.userex.com/images/4/690b8724ab6901ec78d3104c4c20f88f/2.png'); background-repeat: no-repeat; background-position: left top; background-size: 100% auto; position: relative; padding: 20px 0px 15px 0px; top: 0px;" align="left">
<h1 class="titleIntext" style="color: #000000 !important; height: 120px; line-height: 33px; padding: 25px 0px 0px 30px; width: 300px; font-size: 35px;">&nbsp;</h1>
<p>&nbsp;</p>
<table style="border-collapse: separate;" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td class="btnMain esd-block-button es-p10" style="padding: 0px 0px 30px 30px;" align="left"><span class="es-button-border"> <a class="es-button orgBtn" style="font-size: 18px; color: ${buttonTextColor}; background-color: ${buttonGenralColor}; border-radius: ${borderRadius}px; padding: 11px; display: inline-block; width: 250px; text-align: center; text-decoration: none; font-weight: bold;" href="${bodyBtnLink}" target="_blank" rel="noopener">${bodyBtnName}</a> </span></td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr>
<td class="main-table" style="padding: 0px 30px 20px 30px; background: ${backgroundColor}; background-color: ${backgroundColor};">
<table style="background: ${backgroundColor}; color: #484848; width: 100%;" border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td style="line-height: 10px; width: 101.682%;" colspan="3">&nbsp;</td>
</tr>
<tr>
<td style="padding-bottom: 20px; color: #484848; width: 99.8131%;" align="left" valign="top">
<table class="btnForMobile" style="background: ${backgroundColor}; background-color: ${backgroundColor}; display: none; padding: 0px 30px 0px 0px;" border="0" width="250px" cellspacing="0" cellpadding="0" align="center">
<tbody>
<tr>
<td style="font-size: 18px; color: ${backgroundColor}; background-color: ${buttonGenralColor}; border-radius: ${borderRadius}px; padding: 11px; display: inline-block; width: 250px; text-align: center;" align="left" valign="top"><a style="color: ${buttonTextColor}; font-size: 18px; text-align: center; text-decoration: none; display: block; text-transform: uppercase;" href="${bodyBtnLink}" target="_blank" rel="noopener"><strong>${bodyBtnName}</strong></a></td>
</tr>
</tbody>
</table>


     <h1>${headline}</h1>
<br>
<p>${body}</p>
<br />
<table style="background: ${backgroundColor}; background-color: ${backgroundColor};" border="0" width="250px" cellspacing="0" cellpadding="0" align="center">
<tbody>
<tr>
<td style="margin-bottom: 15px; font-size: 18px; color: ${backgroundColor}; background-color: ${buttonGenralColor}; border-radius: ${borderRadius}px; padding: 11px; display: inline-block; width: 250px; text-align: center;" align="left" valign="top"><a style="color: ${buttonTextColor}; font-size: 18px; text-align: center; text-decoration: none; display: block;" href="${bodyBtnLink}" target="_blank" rel="noopener"><strong>${bodyBtnName}</strong></a></td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
<table style="background: ${backgroundColor}; background-color: ${backgroundColor}; color: #484848;" border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td style="color: #484848;" align="left" valign="top">
${additionalText}
</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
<table style="background: ${backgroundColor}; width: 100%;" border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr style="height: 35px;">
<td style="height: 35px;" height="35">&nbsp;</td>
<td style="height: 35px;" align="center" width="620" height="35">&nbsp;</td>
<td style="height: 35px;" height="35">&nbsp;</td>
</tr>
<tr>
<td class="" style="background: ${backgroundColor};" align="center" valign="middle" bgcolor="${backgroundColor}" width="100%">
<table border="0" width="100%" cellspacing="0" cellpadding="0">
<tbody>
<tr>
<td style="line-height: 10px;" colspan="3">&nbsp;</td>
<td style="line-height: 10px;" colspan="3">&nbsp;</td>
<td style="color: #484848; font-size: 16px;" align="justify" valign="top">${disclaimer_marketing}</td>
<td style="line-height: 10px;" colspan="3">&nbsp;</td>
</tr>
</tbody>
</table>
</td>
</tr>
<tr style="height: 35px;">
<td style="height: 35px;" height="5">&nbsp;</td>
<td style="height: 35px;" align="center" width="620" height="5">&nbsp;</td>
<td style="height: 35px;" height="5">&nbsp;</td>
</tr>
</tbody>
</table>
</td>
</tr>
</tbody>
</table>
</td>
<td>&nbsp;</td>
</tr>
<tr>
<td height="45">&nbsp;</td>
<td align="center" width="620" height="45">&nbsp;</td>
<td height="45">&nbsp;</td>
</tr>
</tbody>
</table>
</body>
</html>
      
    `,

    
    
    
  };
  
  export default htmlTemplates;
  